(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["product-metaobject-images"] && !Shopify.designMode) return;
  try {
    document.addEventListener('shopify:section:load', function(event) {
    // Re-initialize if specialized JS was needed
  });
  
  document.addEventListener('shopify:block:select', function(event) {
    const block = event.target;
    // Ensure block is visible when selected
    if (block) {
      block.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
  });
  } catch(e) { console.error(e); }
})();

})();
